import React, { useEffect, useRef, useState } from "react";
import { LoadReceipt } from "../FormComponents/AddPickupMemo/AddLRAutoLR/PickupMemoTypes";
import { LoadTable } from "..";
import LRTable from "./LRTable";
import "./LRTable.scss";
import { MdDelete } from "react-icons/md";
import { WarningToast } from "../ToastComponent/RectHotToast";
import { useSelector } from "react-redux";
import { useLazyQuery } from "@apollo/client";
import { getLMSsalesBillById } from "../../../Utils/VouchersQueryAndMutation/VoucherQueries";
import { ConvertDateValues } from "../../custom_hooks/ChangeDateValues";

interface MemoMainComponentProps {
  data: LoadReceipt[];
  TypeofPortal: string;
  setLR: any;
  totalWeight: (val: number) => void;
  fielddata: any; // Adjust this type according to your actual data structure
  SelectedData: any; // Assuming _id is a string
  createdMemo?: boolean;
  formkey?: string;
  openByCard?: boolean;
  TableHeaders?: any
}
const MemoMainComponent: any = ({
  data,
  TypeofPortal,
  setLR,
  fielddata,
  totalWeight,
  SelectedData = [],
  createdMemo = false,
  formkey = "",
  salesBillID,
  setSalesBillData = (val: any) => { },
  openByCard,
  TableHeaders
}) => {
  const [addedData, setAddedData] = useState<LoadReceipt[]>([]);
  const [tableData, setTableData] = useState(data ? data : []);
  const [getSalesBillData, { loading: getSalesBillDataLoader }] = useLazyQuery(getLMSsalesBillById, {
    fetchPolicy: "network-only",
  });
  // const [selData, setSelData] = useState(SelectedData ? SelectedData : []);
  const myStateRef = useRef(addedData);
  const myStateRef2 = useRef(tableData);
  const FormData = useSelector((store: any) => store?.FormDataReducer);
  useEffect(() => {
    // Update the ref's current value whenever myState changes
    myStateRef.current = addedData;
    myStateRef2.current = tableData;
  }, [addedData, tableData]);
  // console.log(SelectedData, "SelectedData");
  useEffect(() => {
    //after createing  document we need to empty the selected array
    if (createdMemo === true) {
      setLR([]);
      setAddedData([]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createdMemo]);

  useEffect(() => {
    if (
      (FormData?.MasterData?.[formkey]?.From_Connection_Center?._id && formkey) ||
      (FormData?.MasterData?.[formkey]?.Branch_Code?._id && TypeofPortal.includes("Add")) ||
      (FormData[formkey]?.Bill_Details?.Load_Type && TypeofPortal.includes("Add")) ||
      (FormData?.MasterData[formkey]?.Party?.Account_Type_Id && TypeofPortal.includes("Add"))
    ) {
      setAddedData([]);
    }
  }, [
    FormData?.MasterData?.[formkey]?.From_Connection_Center?._id,
    FormData?.MasterData[formkey]?.Branch_Code?._id,
    FormData[formkey]?.Bill_Details?.Load_Type,
    FormData?.MasterData[formkey]?.Party?.Account_Type_Id,
  ]);

  useEffect(() => {
    let Tweight = addedData?.reduce((acc: any, el: any) => acc + Number(el?.Total_Weight || 0), 0);
    totalWeight(Tweight);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addedData]);

  const handleDelete = (index) => {
    // console.log(index, "bubu");
    // if (index < 0 || index >= data.length) {
    //   console.log(index, "bubu", data.length, myStateRef2.current);
    //   console.error("Index out of bounds");
    //   return;
    // }

    let updatedAddedData = [...myStateRef.current];
    const [removedObject] = updatedAddedData.splice(index, 1);
    console.log(updatedAddedData, removedObject, "bubu", data);
    const updatedTableData = [...myStateRef2.current, removedObject];
    updatedAddedData = updatedAddedData?.map((el, i) => {
      let newObj: any = { ...el };
      if (newObj?.__typename) {
        delete newObj.__typename;
      }
      let Del = <MdDelete onClick={() => handleDelete(i)} />;
      return { ...newObj, Del };
    });
    setAddedData(updatedAddedData);
    setTableData(updatedTableData);
    setLR(updatedAddedData);
  };
  const AddLr_from_Input = (res) => {
    const addedElement = addedData?.find((ele) => ele?._id === res?._id);
    let Delete = <MdDelete onClick={() => handleDelete(addedData.length + 1)} />;

    if (addedElement) {
      return WarningToast("This Lr is Already added");
    } else {
      if (addedData.length > 0) {
        const data = [...addedData, { Del: Delete, ...res }];
        setAddedData(data);
        setLR(data);
      } else {
        setAddedData([{ Del: Delete, ...res }]);
        setLR([{ Del: Delete, ...res }]);
      }
    }
  };
  const handleAddData = (newData: LoadReceipt[]) => {
    // const idsToRemove = new Set(newData.map((item: any) => item._id));
    // let temp = tableData.filter((item) => !idsToRemove.has(item._id));
    console.log(newData);
    if (formkey === "Sales_Return") {
      getSalesBillData({ variables: { id: newData[0]?._id } }).then((res) => {
        console.log(res.data?.GetLMSSalesBillById, "lms");
        let salesData = res.data?.GetLMSSalesBillById;
        let LRCNData =
          salesData?.Load_Type == "PTL" ? salesData?.PTL_Consignment_Note_Data : salesData?.FTL_Consignment_Note_Data;

        setTableData(LRCNData);
        setAddedData(ConvertDateValues(LRCNData));
        setLR(LRCNData);
        setSalesBillData(salesData);
      });
    } else {
      setTableData(newData);
      let updatedData = newData?.map((el, i) => {
        let Delete = <MdDelete onClick={() => handleDelete(addedData.length + i)} />;
        return { Del: Delete, ...el };
      });
      setAddedData(updatedData);
      setLR(newData);
    }
  };
  useEffect(() => {
    if ((!TypeofPortal?.includes("Add") || (TypeofPortal?.includes("Add") && openByCard)) && SelectedData[0]?._id) {
      // const seleData = data?.filter((ele: any) => SelectedData?.includes(ele?._id));
      if (formkey === "Sales_Return") {
        setAddedData(SelectedData);
        setLR(SelectedData);
      } else {
        let updatedData = SelectedData?.map((el, i) => {
          let Delete = <MdDelete onClick={() => handleDelete(addedData.length + i)} />;
          return { Del: Delete, ...el };
        });

        setAddedData(updatedData);
        setLR(updatedData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [TypeofPortal, SelectedData]);

  return (
    <div className="AddLRmaindiv lr-table-container">
      <LRTable
        TypeOfPortal={TypeofPortal}
        onAdd={handleAddData}
        data={data}
        formkey={formkey}
        SelectedData={addedData}
        AddLr_from_Input={AddLr_from_Input}
      />

      <div className="pickupdata">
        {!addedData?.length ? (
          <p style={{ textAlign: "center" }}>Data not Available....</p>
        ) : (
          <LoadTable data={addedData} loading={false} error={null} title={`${formkey}_forLRTable`} SelectCheckbox={false} TableHeaders={TableHeaders} />
        )}
      </div>
    </div>
  );
};

export default MemoMainComponent;
